import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import { useGetAgendasQuery } from "../../../api/useGetAgendas";
import { format } from "date-fns";
import { parseISODate, groupByWeek } from "../../../utils/date";

const WeekTable = ({ data, handleAssignmentClose, onRowClick }) => {
  return (
    <TableContainer component={Paper} sx={{ marginBottom: 4 }}>
      <Table sx={{ minWidth: 650 }} aria-label="weekly schedule table">
        <TableHead>
          <TableRow>
            <TableCell width="16.67%">Date</TableCell>
            <TableCell width="16.67%">Day</TableCell>
            <TableCell width="25%">Assignment</TableCell>
            <TableCell width="16.67%">Close</TableCell>
            <TableCell width="25%">탈락자</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((agenda, index) => (
            <TableRow
              key={index}
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(155, 81, 224, 0.2)",
                  cursor: "pointer",
                },
              }}
              onDoubleClick={() => onRowClick(agenda)}
            >
              <TableCell width="16.67%">
                {format(
                  parseISODate(agenda.closeDate.split("T")[0]),
                  "yyyy.MM.dd"
                )}
              </TableCell>
              <TableCell width="16.67%">
                {format(parseISODate(agenda.closeDate.split("T")[0]), "EEEE")}
              </TableCell>
              <TableCell width="25%">{agenda.assignment}</TableCell>
              <TableCell width="16.67%">
                <Typography
                  size="small"
                  color={agenda.isClosed ? "primary" : "error"}
                >
                  {agenda.submissionLinks.length === 0
                    ? "과제 없음"
                    : agenda.isClosed
                    ? "Closed"
                    : "Close"}
                </Typography>
              </TableCell>
              <TableCell width="25%">
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {agenda.dropList.map((user) => (
                    <li key={user.userId._id}>@{user.userId.name}</li>
                  ))}
                </ul>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const AgendaList = ({ selectedStudy, setSelectedAgenda }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const {
    data: agendas,
    isLoading,
    isError,
    error,
  } = useGetAgendasQuery({
    studyId: selectedStudy?._id,
  });

  const weeks = groupByWeek(agendas || []);

  const handleRowClick = (agenda) => {
    if (agenda.submissionLinks.length === 0) return;
    setSelectedAgenda(agenda);
  };
  return (
    <>
      {agendas?.length === 0 || !agendas ? (
        <div>데이터 없음</div>
      ) : (
        <Box item>
          {Object.entries(weeks).map(([weekStart, weekData], index) => (
            <Box key={weekStart}>
              <Typography variant="h6" gutterBottom>
                {"Week " + (index + 1) + " (" + weekStart + ")"}
              </Typography>
              <WeekTable
                key={refreshKey}
                week={weekStart}
                data={weekData}
                // handleAssignmentClose={handleAssignmentClose}
                onRowClick={handleRowClick}
              />
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default AgendaList;
